import { Bot } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="bg-white border-t border-gray-200 px-4 sm:px-6 py-12">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-2">
        <span className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center">
          <Bot className="w-4 h-4 text-white" />
        </span>
        <span className="font-heading font-bold text-lg text-gray-900">AI Central</span>
      </div>
      <p className="text-xs text-gray-500 text-center max-w-md leading-relaxed">
        AI Central is a trading platform matching service. We do not provide investment advice.
        Trading involves risk. Only trade with capital you can afford to lose.
      </p>
      <p className="text-xs text-gray-400">© 2026 AI Central. All rights reserved.</p>
    </div>
  </footer>
);
